'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import useDatabase from '@shared/utils/hooks/useDatabase';
import usePostsShared from '@shared/utils/hooks/usePosts';
import { useQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { client } from '../../../utils/trpc';
import Modal, { ModalContent, ModalHeader } from '../../HOC/Modal';
import PostItem from '../../posts/PostItem';
import Input from '../../UI/Input';
type Props = {
  callback: (postId?: string, isPrivate?: boolean) => void;
  includePrivate?: boolean;
};
const PostSearch = props => {
  const $ = _c(48);
  const [query, setQuery] = useState("");
  const [searchPrivate, setSearchPrivate] = useState(false);
  const {
    queryKey
  } = usePostsShared(client, `PostSearch-${query}`);
  const {
    fetchPrivatePosts
  } = useDatabase();
  let t0;
  if ($[0] !== query) {
    t0 = () => unwrapFromResult(client.posts.feed.query({
      source: "search",
      query
    }));
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !searchPrivate;
  let t2;
  if ($[2] !== queryKey || $[3] !== t0 || $[4] !== t1) {
    t2 = {
      queryKey,
      queryFn: t0,
      enabled: t1
    };
    $[2] = queryKey;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data,
    error,
    isLoading: loading
  } = useQuery(t2);
  let t3;
  if ($[6] !== query) {
    t3 = ["PostSearch-private", query];
    $[6] = query;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== fetchPrivatePosts) {
    t4 = () => fetchPrivatePosts({
      page: 0
    });
    $[8] = fetchPrivatePosts;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== searchPrivate || $[11] !== t3 || $[12] !== t4) {
    t5 = {
      queryKey: t3,
      queryFn: t4,
      enabled: searchPrivate
    };
    $[10] = searchPrivate;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const {
    data: privateData,
    isLoading: privateLoading
  } = useQuery(t5);
  const isLoading = searchPrivate ? privateLoading : loading;
  let t6;
  if ($[14] !== data?.posts || $[15] !== privateData?.posts || $[16] !== searchPrivate) {
    t6 = searchPrivate ? privateData?.posts ?? [] : data?.posts ?? [];
    $[14] = data?.posts;
    $[15] = privateData?.posts;
    $[16] = searchPrivate;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const posts = t6;
  let t7;
  if ($[18] !== props) {
    t7 = () => props.callback();
    $[18] = props;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ModalHeader><p>Search Posts</p></ModalHeader>;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e => setQuery(e);
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== query) {
    t10 = <Input className="mb-2 w-full rounded" label="Search for post or add a link to the post" value={query} onChange={t9} />;
    $[22] = query;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== props.includePrivate || $[25] !== searchPrivate) {
    t11 = props.includePrivate && <div className="flex items-center gap-2"><button onClick={() => setSearchPrivate(false)} className={`rounded-md px-3 py-1 text-sm ${!searchPrivate ? "bg-primary text-white" : "bg-background-secondary text-textSecondary"}`}>Server Posts</button><button onClick={() => setSearchPrivate(true)} className={`rounded-md px-3 py-1 text-sm ${searchPrivate ? "bg-primary text-white" : "bg-background-secondary text-textSecondary"}`}>Private Posts</button></div>;
    $[24] = props.includePrivate;
    $[25] = searchPrivate;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== isLoading) {
    t12 = isLoading && <Loader2 className="absolute inset-y-0 right-6 top-6 animate-spin text-textSecondary/60" />;
    $[27] = isLoading;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== posts || $[30] !== props || $[31] !== searchPrivate) {
    let t14;
    if ($[33] !== props || $[34] !== searchPrivate) {
      t14 = post => <div onClick={_e => {
        props.callback(post.id, searchPrivate);
      }} key={post.id}><PostItem post={post} isFullLength={false} disableLink={true} isInView={true} uniqueId={`PostSearch-${post.id}`} /></div>;
      $[33] = props;
      $[34] = searchPrivate;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    t13 = posts.map(t14);
    $[29] = posts;
    $[30] = props;
    $[31] = searchPrivate;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[36] !== error || $[37] !== searchPrivate) {
    t14 = error && !searchPrivate && <p className="p-4 text-base font-thin">An error occurred. Please try again later.</p>;
    $[36] = error;
    $[37] = searchPrivate;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== t10 || $[40] !== t11 || $[41] !== t12 || $[42] !== t13 || $[43] !== t14) {
    t15 = <ModalContent><div className="space-y-4">{t10}{t11}{t12}{t13}{t14}</div></ModalContent>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
    $[42] = t13;
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== t15 || $[46] !== t7) {
    t16 = <><Modal closeHandler={t7}>{t8}{t15}</Modal></>;
    $[45] = t15;
    $[46] = t7;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  return t16;
};
export default PostSearch;